export default a => {
  try {
    return a.length ? [...new Set(a.map(o => JSON.stringify(o)))].map(s => JSON.parse(s)) : [];
  } catch(err) {
    return [];
  }
};